import { ChevronDown } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface SearchFiltersProps {
  filters: Record<string, string>;
  onUpdateFilter: (key: string, value: string) => void;
}

export function SearchFilters({ filters, onUpdateFilter }: SearchFiltersProps) {
  const { data: authorsData } = useQuery({
    queryKey: ['authors'],
    queryFn: () => api.authors.getAll(),
  });

  const { data: categoriesData } = useQuery({
    queryKey: ['categories'],
    queryFn: () => api.categories.getAll(),
  });

  const authors = authorsData?.data || [];
  const categories = categoriesData?.data || [];

  return (
    <div className="flex flex-wrap gap-3">
      <div className="relative">
        <select
          value={filters.author || ''}
          onChange={(e) => onUpdateFilter('author', e.target.value)}
          className="appearance-none rounded-xl border border-surface-200 bg-white px-4 py-2.5 pr-10 text-sm text-surface-700 transition-all duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20"
        >
          <option value="">All Authors</option>
          {authors.map((a: any) => (
            <option key={a.slug} value={a.slug}>{a.name}</option>
          ))}
        </select>
        <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-surface-400 pointer-events-none" />
      </div>

      <div className="relative">
        <select
          value={filters.category || ''}
          onChange={(e) => onUpdateFilter('category', e.target.value)}
          className="appearance-none rounded-xl border border-surface-200 bg-white px-4 py-2.5 pr-10 text-sm text-surface-700 transition-all duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20"
        >
          <option value="">All Categories</option>
          {categories.map((c: any) => (
            <option key={c.slug} value={c.slug}>{c.name}</option>
          ))}
        </select>
        <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-surface-400 pointer-events-none" />
      </div>

      <div className="relative">
        <select
          value={filters.sort || ''}
          onChange={(e) => onUpdateFilter('sort', e.target.value)}
          className="appearance-none rounded-xl border border-surface-200 bg-white px-4 py-2.5 pr-10 text-sm text-surface-700 transition-all duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20"
        >
          <option value="">Latest</option>
          <option value="oldest">Oldest</option>
          <option value="popular">Most Popular</option>
          <option value="random">Random</option>
        </select>
        <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-surface-400 pointer-events-none" />
      </div>
    </div>
  );
}
